window.ParLaborAPI = new function () {
    var self = this;
    var _protected = BaseAPI.call(self);

    _protected.setApiUrl(publicConfiguration.getBaseAPI("ParLaborServers"));

    self.getParLaborForecasts = function (brandId, mode, startDate, endDate) {
        var defer = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        if (!startDate) {
            throw "start week date are required";
        }

        var params = {
            mode: mode
        };

        if (mode === 'BASIC') {
            params['start_date'] = startDate;
            params['end_date'] = endDate;
        } else {
            params['week'] = startDate;
        }

        _protected.request('brands/' + brandId + '/par_forecasts', 'GET', params)
            .then(function (res) {
                if (res && res.data && res.status === 200) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }

            }, function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.getWeekParForecast = function (brandId, forecastId) {
        var defer = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/par_forecasts/' + forecastId, 'GET')
            .then(function (res) {
                if (res && res.data && res.status === 200) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }

            }, function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.createParForecast = function (brandId, parForecast) {
        var defer = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/par_forecasts', 'POST', parForecast)
            .then(function (res) {
                if (res && res.data && res.status === 200) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }

            }, function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.updateParForecast = function (brandId, forecastId, parForecast) {
        var defer = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/par_forecasts/' + forecastId, 'PUT', parForecast)
            .then(function (res) {
                if (res && res.data && res.status === 200) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }

            }, function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.deleteParForecast = function (brandId, forecastId) {
        var defer = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/par_forecasts/' + forecastId, 'DELETE')
            .then(function (res) {
                if (res && res.data && res.status === 200) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }

            }, function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.getParForecastsTemplates = function (brandId) {
        var defer = $q.defer();

        if (!brandId) {
            throw "No brand id";
        }

        _protected.request('brands/' + brandId + '/par_forecasts/templates', 'GET')
            .then(function (res) {
                if (res && res.data && res.status === 200) {
                    defer.resolve(res.data.data);
                } else {
                    defer.reject(res);
                }

            }, function (err) {
                defer.reject(err);
            });

        return defer.promise;
    };
};